import CustomerStoryVertical from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryVertical"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {CustomerStoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomersCardsSection.module.scss"

type Props = {
	data: CustomerStoryModuleType[]
}

const CustomersCardsSection = (props: Props) => {
	const storiesArray = [
		"bureaucracy-simplified-with-video",
		"ponsse-ceo-cant-imagine-working-without-videos",
		"utilising-video-communication-to-create-a-sense-of-unity-for-scattered-workforce",
	]

	return (
		<ContainerWrapper>
			<div className={styles.cardContainer}>
				{props.data.map(
					(element: CustomerStoryModuleType, index: number) => {
						return (
							<React.Fragment key={index}>
								{storiesArray.map(
									(element2: string, index2: number) => {
										return (
											<React.Fragment key={index2}>
												{element.slug === element2 && (
													<CustomerStoryVertical
														className={
															styles.cardBox
														}
														data={element}
													/>
												)}
											</React.Fragment>
										)
									},
								)}
							</React.Fragment>
						)
					},
				)}
			</div>
		</ContainerWrapper>
	)
}

export default CustomersCardsSection
